import * as React from "react";
import WaitingRoomService from "services/waiting-room-service";
import WaitingRoomDisplay from "components/block-elements/waiting-room-display/waiting-room-display";
import { extract, DateHelper, createDate, LocalStorageHelper, EventAggregator } from "@parksandresorts/core";

const WaitingRoom = (Component) => {
  //eslint-disable-next-line
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        waitingRoomKey: null,
        isInQueue: false,
        yourTurn: false,
        secondsLeft: null,
        message: null,
        isLoading: true,
        placeInQueue: null,
        error: null,
      };

      this.enableWaitingRoom = extract(props, "enableWaitingRoom", false);
      this.pageIsLocked = extract(props, "isLocked", false);
      this.waitingRoomLogo = extract(props, "waitingRoomLogo.file.url", null);

      this.pollWaitingRoom = this.pollWaitingRoom.bind(this);
      this.leaveQueue = this.leaveQueue.bind(this);
      this.getMinutesFromSeconds = this.getMinutesFromSeconds.bind(this);

      this.pollingInterval = null;
      this.pollTimerInMs = 15000;
      this.validKeyTimeInMinutes = 1440;
      this.leftQueue = false;
    }

    componentDidMount() {
      this.mounted = true;

      if (!this.enableWaitingRoom || this.pageIsLocked) {
        return;
      }

      const key = LocalStorageHelper.getItem("waitingRoomKey");

      if (key) {
        this.setState({ waitingRoomKey: key, isInQueue: true }, () => {
          this.pollWaitingRoom();
        });

        this.pollingInterval = setInterval(this.pollWaitingRoom, this.pollTimerInMs);
      } else {
        this.initializeWaitingRoom();
      }
    }

    componentWillUnmount() {
      this.mounted = false;

      if (!this.enableWaitingRoom) {
        return;
      }

      clearInterval(this.pollingInterval);
    }

    initializeWaitingRoom() {
      this.setState({ isLoading: true });

      WaitingRoomService.postWaitingRoomTicket()
        .then((response) => {
          const waitingRoomData = response;

          const key = extract(waitingRoomData, "response.key", null);
          this.setState({ waitingRoomKey: key, isInQueue: true }, () => {
            this.pollWaitingRoom();
          });

          const timeStampDate = DateHelper.addMinutes(createDate(), this.validKeyTimeInMinutes);
          LocalStorageHelper.setItem("waitingRoomKey", key, timeStampDate.getTime());

          this.pollingInterval = setInterval(this.pollWaitingRoom, this.pollTimerInMs);
        })
        .catch((error) => {
          EventAggregator.publish("trackException", {
            exception: error,
            customMessage: "WaitingRoom postWaitingRoomTicket",
          });
          this.setState({ error: "Kunde inte komma åt tjänsten, prova igen om en stund.", isLoading: false });
        });
    }

    pollWaitingRoom() {
      if (!this.state.waitingRoomKey || this.leftQueue) {
        return;
      }

      WaitingRoomService.getWaitingRoomTicket(this.state.waitingRoomKey)
        .then((response) => {
          const yourTurn = extract(response, "response.yourTurn", false);
          const secondsLeft = extract(response, "response.secondsLeft", 0);
          const message = extract(response, "response.message", null);
          const placeInQueue = extract(response, "response.placeInQueue", null);
          const maxSeconds = extract(response, "response.maxSeconds", 0);

          this.setState({
            yourTurn: yourTurn,
            isLoading: false,
            secondsLeft: secondsLeft,
            message: message,
            placeInQueue: placeInQueue,
            maxSecondsInQueue: maxSeconds,
          });
        })
        .catch((err) => {
          if (err.status === 404) {
            clearInterval(this.pollingInterval);
            this.setState({ isInQueue: false, yourTurn: false, isLoading: false });
          }
        });
    }

    leaveQueue() {
      clearInterval(this.pollingInterval);

      if (!this.state.waitingRoomKey) {
        console.log("No key available");
        return;
      }

      WaitingRoomService.deleteWaitingRoomTicket(this.state.waitingRoomKey)
        .then((reponse) => {
          if (this.mounted) {
            this.leftQueue = true;
            console.log("Successfully left queue");
          }
        })
        .catch((error) => {
          if (this.mounted) {
            console.log(error);
          }
        });
    }

    getMinutesFromSeconds(value) {
      if (!value) {
        return null;
      }

      if (value <= 0) {
        return null;
      }

      return Math.ceil(value / 60);
    }

    render() {
      return !this.enableWaitingRoom || this.state.yourTurn ? (
        <Component
          onComplete={() => this.leaveQueue()}
          waitRoomSecondsLeft={this.state.secondsLeft}
          maxMinutesInQueue={this.getMinutesFromSeconds(this.state.maxSecondsInQueue)}
          {...this.props}
        />
      ) : (
        <WaitingRoomDisplay
          waitingRoomLogo={this.waitingRoomLogo}
          isInQueue={this.state.isInQueue}
          isLoading={this.state.isLoading}
          isLocked={this.pageIsLocked}
          placeInQueue={this.state.placeInQueue}
          error={this.state.error}
          message={this.state.message}
          maxSecondsInQueue={this.state.maxSecondsInQueue}
          onRestartQueue={() => this.initializeWaitingRoom()}
        />
      );
    }
  };
};

export default WaitingRoom;
